import { cn } from '@/utils/cn-tw-merge';

function Skeleton({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return <div className={cn('animate-pulse rounded-md bg-gray-200 dark:bg-slate-800', className)} {...props} />;
}

export { Skeleton };
